import DatePicker from 'react-datepicker'

export default function DatePickerIcon(props: any) {
 
  return (
    <>
      <div className='col'>
        <DatePicker
          className='form-control fs-6 example-custom-input'
          selected={props.selected}
          name={props.id}
          dateFormat={props.dateFormat}
          disabled={props.disabled}
          onChange={(date: any) => {
            try {
              props.handleDate(date)
            } catch {}
            return date
          }}
          value={props.value}
          minDate={props.min}
          maxDate={props.max}
          placeholderText={props.placeholderText}
        />
      </div>
    </>
  )
}
